import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  ViewChild,
  Sanitizer,
} from "@angular/core";
import { UI } from "../../services/ui.service";
import { Router } from "@angular/router";
import { MediaRepository } from "../../domain/media-repository";
import { UserService } from "../../domain/user-service";
import { CountryService } from "../../domain/country-service";
import { TagRepository } from "../../domain/tag-repository";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "video-preview",
  templateUrl: "./videoPreview.component.html",
  styleUrls: ["./videoPreview.component.scss"],
})
export class VideoPreviewComponent {
  constructor(
    private ui: UI,
    private element: ElementRef,
    private router: Router,
    private mediaRepository: MediaRepository,
    private user: UserService,
    private countries: CountryService,
    private zone: NgZone,
    private tagRepository: TagRepository,
    private changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
  ) {
    ui.listen(ui.EVENTS.OpenVideoPreview, this.onOpenVideoPreview.bind(this));
  }

  isDragged = false;
  private lastPositionX: number;
  private lastPositionY: number;

  containerScale = 1;
  translateX = 0;
  translateY = 0;

  @ViewChild("fullscreenContainer") fullscreenContainer: ElementRef;
  @ViewChild("preview") preview: ElementRef;

  @Input()
  mediaId: number;

  @Input()
  snapshot: string;

  @Input()
  startTime: number;

  @Input()
  autoPlay: boolean;

  @Input()
  showTimecode: boolean;

  videoUrl: string;

  isVisible = false;
  framerate = 0;

  listener = (e) => this.dismiss(e);

  onOpenVideoPreview(event) {
    this.mediaId = event.data.mediaId;
    this.snapshot = event.data.snapshot;
    this.startTime = event.data.startTime || 0;
    this.autoPlay = event.data.autoPlay || false;
    this.videoUrl = null;
    this.showTimecode = event.data.showTimecode || false;
    this.framerate = event.data.framerate || 0;
    this.containerScale = event.data.scale || 1;
    if (event.data.overridePreviewUrl) {
      this.videoUrl = event.data.overridePreviewUrl;
      this.isVisible = true;

      this.changeDetectorRef.markForCheck();
    } else {
      this.mediaRepository.getMediaPreviewUrl(this.mediaId).then((result) => {
        this.videoUrl = result;
        this.isVisible = true;
        this.changeDetectorRef.markForCheck();
      });
    }

    /* Adding esc handler */
    window.addEventListener("keyup", this.listener, false);
  }

  /**
   * Dismissing The Modal
   */
  dismiss(event?) {
    if (event && event.which !== 27 /* Escape */) {
      return;
    }

    this.close();
  }

  close() {
    this.videoUrl = null;
    this.isVisible = false;
    this.startTime = 0;
    this.autoPlay = false;

    this.ui.notify(this.ui.EVENTS.CloseVideoPreview, {});

    window.removeEventListener("keyup", this.listener, false);
  }

  onMouseDown(event) {
    this.isDragged = true;
    this.lastPositionX = event.clientX;
    this.lastPositionY = event.clientY;
    this.changeDetectorRef.markForCheck();
  }

  onMouseMove(event) {
    if (!this.isDragged) {
      return;
    }

    const diffX = event.clientX - this.lastPositionX;
    const diffY = event.clientY - this.lastPositionY;
    this.lastPositionX = event.clientX;
    this.lastPositionY = event.clientY;

    this.translateX += diffX;
    this.translateY += diffY;
    this.changeDetectorRef.markForCheck();
  }

  onMouseUp(event) {
    this.isDragged = false;
    this.changeDetectorRef.markForCheck();
  }

  sanitizeStyle() {
    return this.sanitizer.bypassSecurityTrustStyle(
      `translate(${this.translateX}px,${this.translateY}px) scale(${this.containerScale})`,
    );
  }
}
